// Money and counts in words. Prices and bids are per million answers, as the
// Exchange states an ask (Design > Names and definitions, "Ask"); earnings are
// plain US dollars.

import { fmtNum } from "../../../ui/src/index.ts";

export const usdFromNano = (nano: number) => nano / 1e9;

/** US dollars: four decimals below a dollar, where single answers live; two above. */
export function usd(amount: number): string {
  if (!Number.isFinite(amount)) return "–";
  const digits = Math.abs(amount) < 1 ? 4 : 2;
  return `$${amount.toLocaleString("en-US", { minimumFractionDigits: digits, maximumFractionDigits: digits })}`;
}

/** A price or bid per million answers: $1,000/M. */
export const perMillion = (usdPerMillion: number) => `$${fmtNum(Math.round(usdPerMillion))}/M`;

/** A bid recorded per answer in nano-dollars, as dollars per million answers. */
export const perMillionFromNano = (nano: number) => nano / 1000;

/** A share as a percentage with one decimal, or "–" when there is no whole. */
export function percent(part: number, whole: number): string {
  if (whole <= 0) return "–";
  return `${((part / whole) * 100).toFixed(1).replace(/\.0$/, "")}%`;
}

/** Milliseconds as seconds with one decimal. */
export const seconds = (ms: number | null) => (ms === null || !Number.isFinite(ms) ? "–" : `${(ms / 1000).toFixed(1)} s`);
